import { FC } from 'react';
import { Icon } from 'features/common/components/Icon';
import { ToggleProps } from './types';
import dolar from 'assets/images/dolar.svg';
import dolarBlack from 'assets/images/dolarBlack.svg';
import percentage from 'assets/images/percentage.svg';
import percentageBlack from 'assets/images/percentageBlack.svg';
import styles from './DiscountToggle.module.css';

const DiscountToggle: FC<ToggleProps> = ({
	id,
	label,
	isPercentage,
	disabled,
	name,
	handleChange,
	...rest
}: ToggleProps) => (
	<div className={styles.inputContainer}>
		{label && <label className="punchupFormLabel">{label}</label>}

		<input
			{...rest}
			aria-label={id ?? name}
			id={id ?? name}
			name={name}
			type="checkbox"
			onChange={handleChange}
			disabled={disabled}
			hidden
			className={styles.input}
		/>

		<div className={styles.backgroundContainer}>
			<span
				className={[styles.background, isPercentage && styles.isPercentage, disabled && styles.disabled]
					.filter(Boolean)
					.join(' ')}
			>
				<div className={styles.uncheckedIconContainer} onClick={disabled ? undefined : handleChange}>
					<Icon src={isPercentage ? dolarBlack : percentageBlack} size="M" />
				</div>
				<span className={styles.circle}>
					<Icon src={isPercentage ? percentage : dolar} size="M" color="white" />
				</span>
			</span>
		</div>
	</div>
);

export { DiscountToggle };
